import React, { useEffect, useState } from "react";

import StoryCard24 from "../../molecules/story-card24";
import CollectionTitleHeader from "../../molecules/collection-title-header";
import Carousel from "../../atoms/carousel";
import Separator from "../../atoms/separator";
import { filterStory } from "../../helper/api";

import "./four-card-slider.m.css";

const FourCardSlider = ({ collection, index }) => {
  if (!(collection && collection.items)) {
    return null;
  }
  const allStories = filterStory(collection);

  if (!allStories.length) {
    return null;
  }
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);

  const stories = allStories.splice(0, 8);
  const totalItemsLength = isMobile ? stories.length : 5;

  return (
    <>
      <CollectionTitleHeader collection={collection} index={index} />
      <div styleName="border-wrapper">
        <div styleName="wrapper">
          <Carousel totalItems={totalItemsLength} slidesToShow={4} showBullets showArrows>
            {stories.map((item, index) => {
              const name = item?.metadata?.["budget-author"];
              if (name) {
                return (
                  <div styleName="story-container" key={index}>
                    <StoryCard24 story={item} />
                  </div>
                );
              }
            })}
          </Carousel>
        </div>
        <Separator />
      </div>
    </>
  );
};

export default FourCardSlider;
